export const CLAUDE_SCORE_MAX = 35;

export type ParsedLabel =
  | { kind: 'score' }
  | { kind: 'dimension'; display: string; value: number }
  | { kind: 'plain'; text: string };

const CLAUDE_LABEL_RE = /^claude-([a-z][a-z-]*):(\d+(?:\.\d+)?)$/;

export function parseLabel(label: string): ParsedLabel {
  if (/^claude-score:/.test(label)) return { kind: 'score' };
  const m = CLAUDE_LABEL_RE.exec(label);
  if (m) return { kind: 'dimension', display: `${m[1]}:${m[2]}`, value: parseFloat(m[2]) };
  return { kind: 'plain', text: label };
}

export function totalScoreColor(
  score: string | null,
): 'green' | 'yellow' | 'red' | 'grey' {
  if (score === null) return 'grey';
  const n = parseFloat(score);
  if (n >= 28) return 'green';
  if (n >= 18) return 'yellow';
  return 'red';
}

export function dimensionColor(value: number): 'green' | 'yellow' | 'red' {
  if (value >= 4) return 'green';
  if (value >= 2) return 'yellow';
  return 'red';
}
